import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomTypeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="11.5"
          stroke="#BCBEC2"
          strokeDasharray="3 3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0995 14.5582L7.36907 10.9453C7.21794 10.7785 7.11833 10.5709 7.08242 10.348C7.04651 10.1251 7.07587 9.89654 7.16689 9.69018C7.25791 9.48381 7.40666 9.30864 7.59494 9.18607C7.78323 9.0635 8.00289 8.99885 8.22707 9.00002L15.9591 9.00002C16.1824 9.00005 16.4008 9.06533 16.588 9.18794C16.7751 9.31055 16.9229 9.48523 17.0134 9.69078C17.104 9.89633 17.1333 10.1239 17.098 10.346C17.0626 10.568 16.9641 10.7749 16.8143 10.9416L13.0838 14.5582C12.9581 14.6974 12.8049 14.8086 12.6341 14.8846C12.4632 14.9607 12.2785 15 12.0917 15C11.9049 15 11.7201 14.9607 11.5493 14.8846C11.3784 14.8086 11.2252 14.6974 11.0995 14.5582Z"
          fill="#BCBEC2"
        />
      </svg>
    </span>
  );
};

export default CustomTypeSVG;
